/* eslint-disable jsx-a11y/click-events-have-key-events */

import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames/bind'

import Icon from '../Icon'

const styles = theme => ({
  label: {
    marginLeft: theme.spacing(4),
    fontSize: theme.typography.fontSizeSm,
    fontWeight: theme.typography.fontWeightBolder,

    '&.labelColorPrimary': {
      color: theme.palette.primary.main,
    },
    '&.labelColorSecondary': {
      color: theme.palette.secondary.main,
    },
    '&.labelColorDefault': {
      color: props => props.labelColor,
    },
  },
  root: {
    border: `1px solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`}`,
    padding: theme.spacing(4),
  },
  withDisable: {
    border: `1px solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`}`,
    padding: theme.spacing(4),
    opacity: '0.5',
    background: `var(--gameday-borders-borderColor, ${theme.borders.borderColor})`,
  },
})

function LabelWithIcon(props) {
  const { iconSize, iconName, iconType, classes, label, labelColor, isDisable, onClick, tabIndex } = props

  let colorClass = ''
  if (labelColor === 'primary') {
    colorClass = 'labelColorPrimary'
  } else if (labelColor === 'secondary') {
    colorClass = 'labelColorSecondary'
  } else {
    colorClass = 'labelColorDefault'
  }
  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: TODO
    // biome-ignore lint/a11y/useSemanticElements: TODO
    <div
      className={isDisable ? classes.withDisable : classes.root}
      onClick={onClick}
      role="button"
      tabIndex={tabIndex || 0}
      aria-label={label}
    >
      <Icon iconType={iconType} iconName={iconName} iconSize={iconSize} />
      <span className={classNames(classes.label, colorClass)}>{label}</span>
    </div>
  )
}

LabelWithIcon.defaultProps = {
  iconSize: 16,
  isDisable: false,
}

export default withStyles(styles)(LabelWithIcon)
